import { memo, useEffect, useState } from "react";
import writeEmitter from "../events/write-emitter.js";
import { run } from "../utils.js";
export const auto = (Component) => {
    return memo(function MyComponent(props) {
        const [, reRender] = useState(0);
        const [r, isTrigger] = run(() => Component(props));
        useEffect(() => {
            const listener = (writeLog) => {
                if (isTrigger(writeLog)) {
                    reRender((n) => n + 1);
                }
            };
            writeEmitter.on(listener);
            return () => {
                writeEmitter.off(listener);
            };
        }, [isTrigger]);
        return r;
    });
};
